/** @format */

import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	Output,
	QueryList,
	ViewChildren,
} from "@angular/core";
import { Router } from "@angular/router";
import { ApiServiceService } from "../../../../../Services/api-service.service";

@Component({
	selector: "app-verify-code",
	templateUrl: "./verify-code.component.html",
	styleUrls: ["./verify-code.component.css"],
})
export class VerifyCodeComponent {
	@Input() details: any;
	@Output() states = new EventEmitter<{ state: boolean }>();
	@Output() moveToStep1 = new EventEmitter<{ step: 1 }>();
	@ViewChildren("inputField") inputFields: QueryList<ElementRef>;

	message: string = "";
	emailPhone: any;
	isChannel: boolean;
	isCodeReady = false;
	isLoading: boolean = false;
	codeSentMSG: string = "";
	codeConfirmMSG: string = "";

	digit1: string = "";
	digit2: string = "";
	digit3: string = "";
	digit4: string = "";
	digit5: string = "";
	digit6: string = "";

	combinedNumber: number | null = null;

	countdownSeconds: number = 30;
	countdownTimer: any;
	isCountDown: boolean = false;

	constructor(
		private router: Router,
		private apiServer: ApiServiceService,
	) {
		this.startCountdown();
	}
	ngOnInit() {
		this.channel("email");
	}
	startCountdown() {
		this.countdownSeconds = 30;
		this.countdownTimer = setInterval(() => {
			if (this.countdownSeconds > 0) {
				this.isCountDown = true;
				this.countdownSeconds--;
			} else {
				this.isCountDown = false;
				clearInterval(this.countdownTimer);
			}
		}, 1000);
	}
	ngOnDestroy() {
		clearInterval(this.countdownTimer);
	}

	screenHeight = window.screen.height - 271; // 1058
	minHeight = "min-height: " + this.screenHeight + "px !important";

	screenHeight2 = window.screen.height - 630; // 428
	minHeight2 = "min-height: " + this.screenHeight2 + "px !important";

	async channel(t) {
		this.isLoading = true;
		if (t == "email") {
			this.emailPhone = "email";
			// console.log('This is the email to use ', this.details.email)
		} else {
			this.emailPhone = "sms";
			// console.log(' This is teh phone number to use ', this.details.phone)
		}

		const url = "/auth/enumeration/send/code";
		const body = {
			email: this.details.email,
			phoneNumber: this.details.phone,
			messageType: this.emailPhone,
		};

		this.apiServer.loginPost_(url, body).subscribe((res) => {
			this.isLoading = false;
			this.codeSentMSG = res.message;
			this.message = res.message;
			if (res.message.includes("sent")) {
				this.isCodeReady = true;
			}
		});
		this.startCountdown();
	}
	proceed() {
		this.isChannel = !this.isChannel;
		this.isCodeReady = false;
	}
	nextInput(event: KeyboardEvent, index: number) {
		const target = event.target as HTMLInputElement;
		const valueLength = target.value.length;
		const maxLength = target.maxLength;

		if (event.key === "Backspace" || event.key === "Delete") {
			if (valueLength === 0 && index > 0) {
				this.inputFields.toArray()[index - 1].nativeElement.focus();
			}
		} else {
			if (
				valueLength >= maxLength &&
				index < this.inputFields.length - 1
			) {
				this.inputFields.toArray()[index + 1].nativeElement.focus();
			}
		}
	}
	goBack() {
		this.moveToStep1.emit({ step: 1 });
	}
	submit() {
		// this.states.emit({state:true})
		const digits =
			this.digit1 +
			this.digit2 +
			this.digit3 +
			this.digit4 +
			this.digit5 +
			this.digit6;
		this.combinedNumber = parseInt(digits, 10);
		const url = "/auth/enumeration/confirm/code";
		const body = {
			email: this.details.email,
			phoneNumber: this.details.phone,
			code: digits,
		};
		this.apiServer.loginPost_(url, body).subscribe((res) => {
			if (res.message.includes("Success")) {
				this.codeConfirmMSG = res.message;
				setTimeout(() => {
					this.states.emit({ state: true });
				}, 1000);
			} else {
				this.codeConfirmMSG = res.message;
			}
		});
	}
}
